import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Loaders } from "@stadium/ui/index";

import { fetchConfig } from "@store/actions/config";

import { selectIsConfigLoading } from "@stadium/redux-utils/selectors/configSelector";

const HOCConfig = ({ children }) => {
  const dispatch = useDispatch();
  const isLoading = useSelector(selectIsConfigLoading);

  useEffect(() => {
    dispatch(fetchConfig());
  }, [dispatch]);

  return isLoading ? <Loaders.PageLoader /> : children;
};

export default HOCConfig;
